/**
 * Page légale générique — rend Mentions / Confidentialité / CGU / RGPD selon le slug.
 * Le contenu est éditable via le CMS (section "legal", longtext HTML).
 *
 * Usage : <LegalPage slug="mentions" /> ou via routing :
 *   <Route path="/mentions-legales" element={<LegalPage slug="mentions" />} />
 */
import { useSiteContent } from "@/lib/useSiteContent";
import { keysFor } from "@/config/cmsSections";


const SLUG_CONFIG = {
    mentions:    { titleKey: "legal.mentions.title",  bodyKey: "legal.mentions.body",  fallbackTitle: "Mentions légales" },
    privacy:     { titleKey: "legal.privacy.title",   bodyKey: "legal.privacy.body",   fallbackTitle: "Politique de confidentialité" },
    cgu:         { titleKey: "legal.cgu.title",       bodyKey: "legal.cgu.body",       fallbackTitle: "Conditions Générales d'Utilisation" },
    rgpd:        { titleKey: "legal.rgpd.title",      bodyKey: "legal.rgpd.body",      fallbackTitle: "Conformité RGPD" },
};


export default function LegalPage({ slug }) {
    const c = useSiteContent(keysFor("legal"));
    const conf = SLUG_CONFIG[slug] || SLUG_CONFIG.mentions;
    const title = c(conf.titleKey, conf.fallbackTitle);
    const body = c(conf.bodyKey, "");

    return (
        <div className="em-container py-16 max-w-3xl" data-testid={`legal-${slug}`}>
            <p className="em-eyebrow">Légal</p>
            <h1 className="font-display text-4xl md:text-5xl font-black tracking-tight text-primary mt-2">
                {title}
            </h1>
            <article
                className="prose prose-neutral mt-10 max-w-none
                           prose-headings:font-display prose-headings:text-primary prose-headings:font-bold
                           prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-3
                           prose-h3:text-lg prose-h3:mt-6 prose-h3:mb-2
                           prose-p:text-foreground prose-p:leading-relaxed
                           prose-li:text-foreground
                           prose-strong:text-primary"
                dangerouslySetInnerHTML={{ __html: body }}
            />
        </div>
    );
}
